<template>
  <div class="sedform-container">
    <div class="sed-form-sended py-5" v-if="formSended">
      <div class="font-weight-bold">{{$t('sedForm.confirmation')}}</div>
      <div class="mt-3">
        {{$t('formComponent.thankyForRequest')}}
      </div>
      <div class="text-center mt-4">
        <v-btn
          tile
          color="#549EC7"
          class="sed-form-sended-agree elevation-0 text-center"
          @click="resetForm()"
          >{{$t('formComponent.agree')}}</v-btn
        >
      </div>
    </div>
    <v-form
      v-else
      class="pa-4"
      v-model="formValidation"
      ref="form"
      @submit.prevent="submit"
    >
      <div class="d-flex">
        <span class="font-weight-bold mb-4">{{$t('sedForm.paymentOrderForm')}}</span>
        <v-spacer />
        <span class="text--disabled">{{$t('sedForm.allFieldsRequired')}}</span>
      </div>
      <div class="feedback-form">
        <div class="feedback-form-block">
          <label>{{$t('sedForm.nameOfCompany')}} <span class="require">*</span> </label>
          <div class="feedback-form-inputs">
            <v-text-field
              outlined
              dense
              :rules="required"
              :shaped="false"
              v-model="formModel.CompanyName"
            >
            </v-text-field>
          </div>
        </div>
      </div>
      <div class="feedback-form-block">
        <div class="feedback-form-inputs">
          <div class="feedback-form-input">
            <label>{{$t('sedForm.FullName')}} <span class="require">*</span> </label>
            <v-text-field
              outlined
              dense
              v-model="formModel.PersonName"
              :rules="required"
            ></v-text-field>
          </div>
          <div class="feedback-form-input">
            <label>{{$t('formComponent.numberOfphone')}} <span class="require">*</span> </label>
            <v-text-field
              outlined
              dense
              v-mask="'###-###-##-##'"
              prefix="+38"
              :rules="phoneRulse"
              v-model="formModel.PhoneNumber"
            ></v-text-field>
          </div>
          <div class="feedback-form-input">
            <label>Email <span class="require">*</span> </label>
            <v-text-field
              dense
              outlined
              :rules="emailRules"
              v-model="formModel.Email"
            ></v-text-field>
          </div>
        </div>
      </div>

      <div class="feedback-form-block">
        <div class="feedback-form-inputs">
          <div class="feedback-form-input">
            <label>{{$t('formComponent.summary')}} <span class="require">*</span> </label>
            <v-textarea
              :rules="required"
              dense
              outlined
              v-model="formModel.ShortDescription"
            >
            </v-textarea>
          </div>
        </div>
      </div>

      <div class="feedback-form-block">
        <div class="feedback-form-inputs">
          <div class="feedback-form-input">
            <label>Компоненти АСКОД під час роботи з якими виник інцидент, версія СЕД АСКОД <span class="require">*</span> </label>
            <v-textarea
              :rules="required"
              dense
              outlined
              v-model="formModel.ErrorDescription"
            >
            </v-textarea>
          </div>
        </div>
      </div>
      <VueFileAgent
        helpText="Додати файл"
        :multiple="true"
        ref="fileAgent"
        theme="list"
        @beforedelete="onBeforeDelete"
        :maxSize="'5MB'"
        :deletable="true"
        :errorText="{
            type: 'Please select images, videos, pdf or zip files',
            size: 'Файл повинен бути менше ніж 5МБ'
          }"
        accept=".doc, .pdf, .docx, .xls., .xlsx"
        v-model="files"
      />
      <app-captcha  ref="recaptcha" :isBudgeHidden="false" @verify="submit($event)" />
      <div class="d-flex align-center justify-space-around">
        <v-btn
          :loading="loading"
          tile
          class="submit-form-button"
          type="submit"
          elevation="0"
          color="#549EC7"
        >
          {{$t('formComponent.send')}}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>
import serviceDataAccess from '../../../services/service.data-access'
import { required, email, phone } from '@/utils/validation-rules'
import AppCaptcha from '../../_shared/AppCaptcha.vue'
import { keys } from 'lodash'

export default {
  components: { AppCaptcha },
  name: 'TechSupportForm',
  data: () => ({
    formModel: {},
    files: [],
    formValidation: false,
    loading: false,
    formSended: false
  }),
  methods: {
    async submit(token) {
      this.$refs.recaptcha.execute()
      const isValid = await this.$refs.form.validate()
      try {
        if (isValid) {
          this.loading = true
          this.formModel.googleReCaptchaResponse = token
          const formData = new FormData()

          if (this.files) {
            this.files.forEach((file) => {
              formData.append('files', new File([file.file], file.name()))
            })
          }
          const formKeys = keys(this.formModel)
          formKeys.forEach((key) => {
            formData.append(key, this.formModel[key])
          })
          formData.append('googleReCaptchaResponse', token)

          await serviceDataAccess.sendTechSupportForm(formData)
          this.$uiService.success('Форма відправлена успішно')

          this.formSended = true
        }
      } catch (e) {
        this.$uiService.error('Помилка відправки форми', e)
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      this.formModel = {}
      this.formSended = false
    }
  },
  computed: {
    required: () => [required],
    phoneRulse: function () {
      return [required, phone]
    },
    emailRules: function () {
      return [required, email]
    }
  }
}
</script>
<style lang="scss" scoped>
.sedform-container {
  font-size: 1.7rem;

  .sed-form-sended-agree {
    color: white;
    text-transform: none;
    font-size: 1.6rem;
  }
  .v-input {
    margin-top: 0.2rem;
  }

  .feedback-form-block-title {
    font-weight: bold;
  }

  .require {
    color: red;
  }
}

.header {
  h1 {
    font-size: 3.8rem;
  }
}
</style>
